import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import { setPayload } from '../../../redux/reducer/payload';
import StopLossAndTakeProfit from './StopLossAndTakeProfit';
import BuySellButton from './ActionButton';
import { TradeContext } from '../context/TradeContextProvider';
import { cn, DirectionIcons, InputNumericStepper } from '@vt/vt-ui';

export const typeExec = {
  0: 'Buy',
  1: 'Sell',
  2: 'Buy Limit',
  3: 'Sell Limit',
  4: 'Buy Stop',
  5: 'Sell Stop',
  6: 'Buy Stop Limit',
  7: 'Sell Stop Limit'
};

const TradeFunction = memo(() => {
  const payload = useAppSelector((state) => state.payload?.payload);
  const dispatch = useAppDispatch();
  const { instrumentInfo, lotSize, handleLotSize, inputLotSize, validateLotSize } =
    useContext(TradeContext);
  const ref = useRef();
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (lotSize && typeof lotSize === 'number') {
      ref.current.value = lotSize.toFixed(2);
    }
  }, [lotSize]);

  return (
    <div>
      <div className="flex justify-between mt-[10px] px-[12px]">
        <div className="text-[#e5e5e5] text-sm">Volume</div>
        <div className="text-[#e5e5e5] text-sm">
          {(+lotSize * instrumentInfo?.contract_size).toFixed(2)} {instrumentInfo.calc_mode > 0 ? instrumentInfo?.description : instrumentInfo?.currency_base}
        </div>
      </div>
      <div className="px-[12px]">
        <div className={cn("relative border hover:border-[#0FEF9E] rounded-lg mt-2", isFocused ? "border-[#0FEF9E]" : "border-[#4B4B4B]")}>
          <input
            onChange={({ target: { value } }) => inputLotSize(value)}
            onBlur={({ target: { value } }) => {
              validateLotSize(value);
              setIsFocused(false);
            }}
            onFocus={() => setIsFocused(true)}
            type="number"
            value={lotSize.toLocaleString()}
            ref={ref}
            step={(instrumentInfo?.volume_step / 10000).toString()}
            className="input-left-lotsize p-[10px] text-[#e5e5e5] !w-[calc(100%-24px)]"
            style={{ caretColor: isFocused ? '#0FEF9E' : 'auto' }}
          />
          <div className="absolute right-0 top-0 bottom-0 flex w-6 flex-col rounded-r-lg border-l border-[#4b4b4b] hover:border-[#0FEF9E]">
            <button
              type="button"
              className={cn(
                'vt-flex group hover:bg-[#0FEF9E] hover:border-[#0FEF9E] flex-1 items-center justify-center rounded-tr-md border-b border-[#4b4b4b] transition-colors',
              )}
              onClick={() => handleLotSize('dec')}
            >
              <DirectionIcons.Up className="h-4 w-4 stroke-neutral-400 fill-neutral-400 group-hover:stroke-[#151515] group-hover:fill-[#151515] transition-colors" />
            </button>
            <button
              type="button"
              className={cn(
                'vt-flex group flex-1 hover:bg-[#0FEF9E] hover:border-[#0FEF9E] items-center justify-center rounded-br-md transition-colors',
              )}
              onClick={() => handleLotSize('inc')}
            >
              <DirectionIcons.Down className="h-4 w-4 stroke-neutral-400 fill-neutral-400 group-hover:stroke-[#151515] group-hover:fill-[#151515] transition-colors" />
            </button>
          </div>
        </div>
        <StopLossAndTakeProfit />
      </div>
      <div className="mt-4 px-[12px]">
        <div className="text-sm text-[#e5e5e5]">Fill Policy</div>
        <div className="mt-2">
          <div className="flex w-100 justify-between">
            <div className="flex items-center text-[#e5e5e5]">
              <input
                className={`custom-radio${payload?.type_fill === 0 ? ' custom-radio--active' : ''}`}
                checked={payload?.type_fill === 0}
                onChange={({ target: { value } }) => {
                  dispatch(setPayload({ ...payload, type_fill: 0 }));
                }}
                type="checkbox"
                value={0}
                style={
                  payload?.type_fill === 0
                    ? {
                      border: '1px solid #0FEF9E',
                      boxShadow: '0 0 0 0px #0FEF9E'
                    }
                    : {}
                }
              />
              <div>
                <p className="text-[#e5e5e5]">Fill or Kill</p>
                <p className='text-[#e5e5e5]'> (FOK)</p>
              </div>
            </div>
            <div className="flex items-center text-[#e5e5e5]">
              <input
                className={`custom-radio${payload?.type_fill === 1 ? ' custom-radio--active' : ''}`}
                checked={payload?.type_fill === 1}
                onChange={({ target: { value } }) => {
                  dispatch(setPayload({ ...payload, type_fill: 1 }));
                }}
                type="checkbox"
                value={1}
                style={
                  payload?.type_fill === 1
                    ? {
                      border: '1px solid #0FEF9E',
                      boxShadow: '0 0 0 0px #0FEF9E'
                    }
                    : {}
                }
              />
              <div>
                <p className="text-[#e5e5e5]">
                  Immediate <br />
                  or Cancel
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BuySellButton typeBuy={0} />
    </div>
  );
});

TradeFunction.displayName = 'TradeFunction';

export default TradeFunction;
